<template>
  <IndicatorCard
    :loading="loading"
    :has-data="solutions.length > 0"
    :is-result="isResult"
    :no-data-message="$t('Nenhuma solução encontrada')"
    :title="title"
    :description="indicator.description"
    :excel-endpoint="indicator.excelEndpoint"
    :hide-excel="!isResult"
    :excel-loading="excelLoading"
    @export-excel="requestExcel"
  >

    <template #date-range>
      <DateRangePicker
        :start-date="startDate"
        :end-date="endDate"
        :disabled="isResult"
        @change="onDateRangeChange"
      />
    </template>

      <v-row class="ma-0" justify="center">
        <v-col cols="12">
          <v-simple-table class="main-table" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th></th>
                  <th class="text-left">
                    <span class="ml-4"> {{ $t('Solução') }} </span>
                  </th>
                  <th class="text-center">{{ $t('Total de O.S.s') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in solutions" :key="item.id">
                  <td></td>
                  <td style="max-width: 60px">
                    <span class="ml-2"> {{ item.solution }} </span>
                  </td>
                  <td style="max-width: 60px" class="text-center">
                    {{ item.orders.length }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

    <template #review>
    

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult && review">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else-if="!isResult">
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
    </template>
  </IndicatorCard>
</template>

<script>
import { getIndicatorById } from '../../../../../indicators/indicatorRegistry'
import ApiService from '../../../../../../../../services/ApiService'
import moment from 'moment'
import IndicatorCard from '../../shared/IndicatorCard.vue'
import DateRangePicker from '../../shared/DateRangePicker.vue'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  name: 'DefectSolutionPrev',

  props: {
    title: { type: String, default: '' },
    apiEndpointOverride: { type: String, default: '' },
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  components: {
    IndicatorCard,
    DateRangePicker,
    TiptapVuetify,
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    if (this.filterProp) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  data() {
    return {
      excelLoading: false,
      loading: true,
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {
        review: '',
      },
      startDate: null,
      endDate: null,
      apiService: new ApiService(),
      showChart: false,
      solutions: [],
    }
  },
  computed: {
    indicator() {
      return getIndicatorById('defect_solution_prevalence') || {}
    },
  },


  methods: {
    onDateRangeChange({ startDate, endDate }) {
      this.startDate = startDate
      this.endDate = endDate
      this.filterProp.data = null
      this.list()
    },

    requestExcel() {
      if (!this.indicator.excelEndpoint) return
      this.excelLoading = true
      const filename = `${this.indicator.legacyKey}.xlsx`
      this.apiService
        .post(this.indicator.excelEndpoint, { ...this.filter, pageSize: 999999 })
        .then((response) => {
          const data = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = data
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .finally(() => {
          this.excelLoading = false
        })
    },

    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: getIndicatorById('defect_solution_prevalence').legacyKey,
        ...this.filter,
        data: null,
      }
      this.$emit('setInfos', model)
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async list() {
      this.loading = true
      try {
        if (this.filterProp.data) {
          const response = JSON.parse(this.filterProp.data)
          this.solutions = response.content.objects
          this.showChart = !this.showChart
          return
        }

        if (!this.isResult) this.setDates()
        this.filter.institutionId = this.institution.id
        this.filter.pageSize = 7
        this.filter.unidadeIds = this.unidades
        const response = await this.apiService.post(
          this.apiEndpointOverride || 'reports/defectSolutionPrevalence',
          this.filter
        )
        this.solutions = response.content.objects
        this.showChart = !this.showChart
      } finally {
        this.loading = false
      }
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>
